import React, { Suspense } from "react";
import { Link, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { Permissions, PermissionType } from "../../../util/Permissions";
import CreateTheme from "./themes/create-theme/CreateTheme";
import { ViewThemes } from "./themes/view-themes/ViewThemes";
import { EditTheme } from "./selected-theme/edit-theme/EditTheme";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { Permission } from "../../Common/layout/Permission";

export default function ThemeManagementPages() {
    const ThemeActions = () => <Permission permission={Permissions.THEMES} permissionType={PermissionType.CREATE}>
        <div className="bg-white border-top px-4">
            <Link to="/themes/create" className={`btn btn-dark w-100 h-40 my-2 my-lg-3`}>
                Create Theme
            </Link>
        </div>
    </Permission>
    return (
        <>
            <AsideMenu>
                <UserGroupMenu destination="/themes/view" actionsMenu={ThemeActions}/>
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <div className="py-4 px-6">
                        <Switch>
                            <ContentRoute path="/themes/create" permission={Permissions.THEMES} permissionType={PermissionType.CREATE} component={CreateTheme} />
                            <ContentRoute path="/themes/edit/:userGroup/:themeId" permission={Permissions.THEMES} permissionType={PermissionType.UPDATE} component={EditTheme} />
                            <ContentRoute path="/themes/view/:userGroup" permission={Permissions.THEMES} permissionType={PermissionType.READ} component={ViewThemes} />
                        </Switch>
                    </div>
                </Suspense>
            </Section>
        </>
    );
}